module.exports = __webpack_public_path__ + "img/icon_mouse_mid.4bb2db29.png";